module.exports = __webpack_public_path__ + "static/media/biglietti-card.f575576e.png";